const dataRoadmap = [
    {
        id: 1,
        title: 'Initial Offering',
        class: 'left',
        list: [
            {
                id: 1,
                text: 'Comprising 20% tokens (42MM)',
            },
            {
                id: 2,
                text: '@ REM energy production start date',
            },
            {
                id: 3,
                text: 'Latest release date 15th November 2024',
            }
        ]
    },
    {
        id: 2,
        title: 'Second Tranche',
        class: 'right',
        list: [
            {
                id: 1,
                text: '@ Cumulative production of 2TWh energy',
            },
            {
                id: 2,
                text: 'Equal to production capacity of 77 REM-stm',
            },
            {
                id: 3,
                text: 'Release of further 20% tokens (42MM)',
            },
            {
                id: 4,
                text: 'Fallback latest release date 21st February 2026',
            }
        ]
    },
    {
        id: 3,
        title: 'Third Tranche',
        class: 'left',
        list: [
            {
                id: 1,
                text: '@ Cumulative produced energy of 20TWh',
            },
            {
                id: 2,
                text: 'Release of 20% tokens (42MM)',
            },
            {
                id: 3,
                text: 'Contingency release date 18th November 2027',
            }
        ]
    },
    {
        id: 4,
        title: 'Fourth Tranche',
        class: 'right',
        list: [
            {
                id: 1,
                text: '@ Cumulative energy generated = 70TWh',
            },
            {
                id: 2,
                text: 'Release of 30% tokens (63MM)',
            },
            {
                id: 3,
                text: 'Contingency release date 15th December 2028',
            }
        ]
    },
    {
        id: 5,
        title: 'Fifth Tranche',
        class: 'left',
        list: [
            {
                id: 1,
                text: '@ Cumulative energy generated = 150TWh',
            },
            {
                id: 2,
                text: 'Release of remaining tokens',
            },
            {
                id: 3,
                text: 'Latest date of release = 15th December 2029',
            }
        ]
    }
];

export default dataRoadmap;
